export default __webpack_public_path__ + "static/media/userlight.a3867c46.svg";